import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Grid,
  Box,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { apiStore } from "../../api/ApiFactory";
import { useSelector } from "react-redux";
import { getSeriesList } from "../../store/slices/BoatOrdering/BoatOrderingSelector";
import SmartText from "../../components/smartText/SmartText";
import { useAppSelector } from "../../store/hooks/hook";
import { NavMode } from "../../helpers/enums/Layout";

const BoatOrderingSeries = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const seriesList = useSelector(getSeriesList);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { navMode } = useAppSelector((state) => ({
      navMode: state.reducer.Layout.navMode
  }));

  useEffect(() => {
    apiStore.boatOrderingApi
      .getSeriesList()
      .then((response) => {
        setIsLoading(false);
          //Log the event in Google Tag Manager for tracking.
          if (navMode === NavMode.LEADS) {
              (window as any).dataLayer = (window as any).dataLayer || [];
              (window as any).dataLayer.push({
                  event: 'manual_page_view',
                  page_title: "Build My Boat",
                  page_path: window.location.pathname,
                  page_location: window.location.href,
              });
          }
      })
      .catch((error) => {
        console.error("Boat series", error);
      });
  }, []);

  const goToModel = (key: any) => {
    if (location.pathname === "/order") {
      navigate(`/order/model/${key}`);
    } else {
      navigate(`/boat/model/${key}`);
    }
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Grid container spacing={{ xs: 2, md: 3 }}>
      {seriesList?.map((series: any, index: number) => {
        return (
          <Grid
            item
            xl={3}
            lg={4}
            md={4}
            sm={12}
            key={index}
            className="container-grid"
          >
            <Card className="configureCard">
              <CardMedia
                component="img"
                height="250"
                image={series?.mediaUrl}
                alt={series.name}
              />
              <CardContent className="configureCardContent">
                <Typography
                  gutterBottom={false}
                  variant="h5"
                  component="div"
                  align="left"
                  className="configureCardHeading"
                  mt={2}
                >
                  {`${series.name}`}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  align="left"
                  gutterBottom
                  className="configureCardModel"
                >
                  {`${series?.modelCount ? series?.modelCount : 0}+ Model(s)`}
                </Typography>
                <Box className="configureCardDescription">
                  <SmartText text={series?.description} char={150} />
                </Box>
                <CardActions className="justify-center">
                  <Button
                    size="small"
                    variant="contained"
                    disabled={!series?.modelCount}
                    className="text-capitalize configureCardButton boat-ordering"
                    onClick={() => goToModel(series.id)}
                  >
                    View All Models
                  </Button>
                </CardActions>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default BoatOrderingSeries;
